import styled from "@emotion/styled";
import { Headline6 } from "@material/react-typography";
import React from "react";
import { ProjectFolderActions } from "./project-folder-actions";
import { GroupedFolderActions } from "./grouped-folder-actions";
import { FolderIcon } from "./FolderIcon";
import { useProjectFoldersPageApi } from "./ProjectFoldersPageApi";
import { ProjectFolderInfo } from "./ProjectFolderInfo";
import { ClientFolderInfo } from "./ClientFolderInfo";
import { GroupedFolderInfo } from "./GroupedFolderInfo";
import { InfoLabel } from "./components/InfoLabel";
import { CustomerFolderActions } from "./customer-folder-actions";
import { getFolderName } from "./utils";

const FolderTitle = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 16px;

  & > h6.mdc-typography {
    margin: 0;
  }
`;

const FolderPlaceholderCaption = styled(Headline6)`
  &.mdc-typography--headline6 {
    color: gray;
    margin-top: 16px;
  }
`;

export const FolderPane: React.FC = () => {
  const { selectedFolder: folder, sharedDrives: driveOptions } =
    useProjectFoldersPageApi();

  if (folder === null) {
    return (
      <FolderPlaceholderCaption>(No folder selected)</FolderPlaceholderCaption>
    );
  }

  const folderName = getFolderName(folder);

  let userFriendlyLabel: string;
  switch (folder.__typename) {
    case "CustomerFolder":
      userFriendlyLabel = `Client: ${folderName}`;
      break;
    case "StructuralFolder":
      userFriendlyLabel = `Folder: ${folderName}`;
      break;
    case "ProjectFolder":
      userFriendlyLabel = `Project: ${folderName}`;
      break;
    case "GroupedFolder":
      userFriendlyLabel = `Grouped folder: ${folderName}`;
      break;
    case undefined:
      userFriendlyLabel = "Misc. Folder";
  }

  return (
    <>
      <FolderTitle>
        <FolderIcon type={folder.__typename} label={true} />
        <Headline6>{userFriendlyLabel}</Headline6>
      </FolderTitle>
      {folder.__typename === "CustomerFolder" && (
        <>
          {!folder.customerNumber ? (
            <>
              <InfoLabel>Customer pending</InfoLabel>
            </>
          ) : (
            <>
              <ClientFolderInfo customerNumber={folder.customerNumber} />
            </>
          )}
          <CustomerFolderActions folder={folder} />
        </>
      )}
      {folder.__typename === "ProjectFolder" && (
        <>
          <ProjectFolderInfo projectNumber={folder.projectId} />
          <ProjectFolderActions folder={folder} driveOptions={driveOptions} />
        </>
      )}
      {folder.__typename === "GroupedFolder" && (
        <>
          <GroupedFolderInfo folder={folder} />
          <GroupedFolderActions folder={folder} driveOptions={driveOptions} />
        </>
      )}
    </>
  );
};
